import type { Kpi } from '@/types/schema/kol/kpi-schema'
import type { KpiSchema } from '@/types/schema/kpi-schema'

const convertKpiToKpiSchema = (kpi: Kpi): KpiSchema => {
  return {
    platform: kpi.platform,
    follower: kpi.follower,
    avgPv6m: kpi.avg_pv_6m,
    avgPv3m: kpi.avg_pv_3m,
    avgComment3m: kpi.avg_comment_3m,
    avgComment6m: kpi.avg_comment_6m,
    avgLike3m: kpi.avg_like_3m,
    avgLike6m: kpi.avg_like_6m,
    avgRepostAndQuoteCount3m: kpi.avg_repost_and_quote_count_3m,
    avgRepostAndQuoteCount6m: kpi.avg_repost_and_quote_count_6m,
    likeCommentRatio3m: kpi.like_comment_ratio_3m,
    likeCommentRatio6m: kpi.like_comment_ratio_6m,
    interactiveRate3m: kpi.interactive_rate_3m,
    interactiveRate6m: kpi.interactive_rate_6m,
    interactive3m: kpi.interactive_3m,
    interactive6m: kpi.interactive_6m,
    avgPvRate3m: kpi.avg_pv_rate_3m,
    avgPvRate6m: kpi.avg_pv_rate_6m,
    fansUpRate3m: kpi.fans_up_rate_3m,
    fansUpRate6m: kpi.fans_up_rate_6m,
    avgShare3m: kpi.avg_share_3m,
    avgShare6m: kpi.avg_share_6m,
    postCount3m: kpi.post_count_3m,
    postCount6m: kpi.post_count_6m,
    fansUpRateCount3m: kpi.fans_up_rate_count_3m,
    fansUpRateCount6m: kpi.fans_up_rate_count_6m,
    avgLiveViewCount6m: kpi.avg_live_view_count_6m,
    avgLiveViewCount3m: kpi.avg_live_view_count_3m,
    avgLiveViewRate6m: kpi.avg_live_view_rate_6m,
    avgLiveViewRate3m: kpi.avg_live_view_rate_3m,
    avgShortViewRate6m: kpi.avg_short_view_rate_6m,
    avgShortViewRate3m: kpi.avg_short_view_rate_3m,
    avgShortViewCount6m: kpi.avg_short_view_count_6m,
    avgShortViewCount3m: kpi.avg_short_view_count_3m,
    avgShortEngagementCount3m: kpi.avg_short_engagement_count_3m,
    avgShortEngagementCount6m: kpi.avg_short_engagement_count_6m,
    avgShortLikeCount3m: kpi.avg_short_like_count_3m,
    avgShortLikeCount6m: kpi.avg_short_like_count_6m,
    avgShortCommentCount3m: kpi.avg_short_comment_count_3m,
    avgShortCommentCount6m: kpi.avg_short_comment_count_6m,
    postFrequency3m: kpi.post_frequency_3m,
    postFrequency6m: kpi.post_frequency_6m,
    postWordOfMouthVolume3m: kpi.post_word_of_mouth_volume_3m,
    postWordOfMouthVolume6m: kpi.post_word_of_mouth_volume_6m,
    videoWordOfMouthVolume3m: kpi.video_word_of_mouth_volume_3m,
    videoWordOfMouthVolume6m: kpi.video_word_of_mouth_volume_6m,
    avgShortPlayCount3m: kpi.avg_short_play_count_3m,
    avgShortPlayCount6m: kpi.avg_short_play_count_6m,
    avgShortPlayRate3m: kpi.avg_short_play_rate_3m,
    avgShortPlayRate6m: kpi.avg_short_play_rate_6m,
    avgShortEngagementRate3m: kpi.avg_short_engagement_rate_3m,
    avgShortEngagementRate6m: kpi.avg_short_engagement_rate_6m,
    minImageEstimatedReachCount3m: kpi.min_image_estimated_reach_count_3m,
    maxImageEstimatedReachCount3m: kpi.max_image_estimated_reach_count_3m,
    minImageEstimatedReachCount6m: kpi.min_image_estimated_reach_count_6m,
    maxImageEstimatedReachCount6m: kpi.max_image_estimated_reach_count_6m,
    minVideoEstimatedReachCount3m: kpi.min_video_estimated_reach_count_3m,
    maxVideoEstimatedReachCount3m: kpi.max_video_estimated_reach_count_3m,
    minVideoEstimatedReachCount6m: kpi.min_video_estimated_reach_count_6m,
    maxVideoEstimatedReachCount6m: kpi.max_video_estimated_reach_count_6m,
    minShortEstimatedReachCount3m: kpi.min_short_estimated_reach_count_3m,
    maxShortEstimatedReachCount3m: kpi.max_short_estimated_reach_count_3m,
    minShortEstimatedReachCount6m: kpi.min_short_estimated_reach_count_6m,
    maxShortEstimatedReachCount6m: kpi.max_short_estimated_reach_count_6m,
    score3m: kpi.score_3m,
    score6m: kpi.score_6m,
    sponsorPostRatio3m: kpi.sponsor_post_ratio_3m,
    sponsorPostRatio6m: kpi.sponsor_post_ratio_6m,
    audience: kpi.audience
      ? {
          mainGender: kpi.audience.main_gender,
          mainAge: kpi.audience.main_age,
        }
      : undefined,
    potential: kpi.potential,
    isCrawlerRunning: kpi.is_crawler_running,
    isCrawlerTriggered: kpi.is_crawler_triggered,
    updateTime: kpi.update_time,
    latestDataUpdatedAt: kpi.latest_data_updated_at,
    interactiveRatePerformance1m: kpi.interactive_rate_performance_1m,
    interactiveRatePerformance3m: kpi.interactive_rate_performance_3m,
    interactiveRatePerformance6m: kpi.interactive_rate_performance_6m,
    avgPvRatePerformance1m: kpi.avg_pv_rate_performance_1m,
    avgPvRatePerformance3m: kpi.avg_pv_rate_performance_3m,
    avgPvRatePerformance6m: kpi.avg_pv_rate_performance_6m,
    fansUpRatePerformance1m: kpi.fans_up_rate_performance_1m,
    fansUpRatePerformance3m: kpi.fans_up_rate_performance_3m,
    fansUpRatePerformance6m: kpi.fans_up_rate_performance_6m,
    avgShortViewRatePerformance1m: kpi.avg_short_view_rate_performance_1m,
    avgShortViewRatePerformance3m: kpi.avg_short_view_rate_performance_3m,
    avgShortViewRatePerformance6m: kpi.avg_short_view_rate_performance_6m,
    avgCommentLikeRatePerformance1m: kpi.avg_comment_like_rate_performance_1m,
    avgCommentLikeRatePerformance3m: kpi.avg_comment_like_rate_performance_3m,
    avgCommentLikeRatePerformance6m: kpi.avg_comment_like_rate_performance_6m,
    avgShortEngagementRatePerformance1m:
      kpi.avg_short_engagement_rate_performance_1m,
    avgShortEngagementRatePerformance3m:
      kpi.avg_short_engagement_rate_performance_3m,
    avgShortEngagementRatePerformance6m:
      kpi.avg_short_engagement_rate_performance_6m,
    quotations: kpi.quotations,
  }
}

export default convertKpiToKpiSchema
